var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "p-20" },
    [
      _c(
        "van-form",
        {
          ref: "form",
          attrs: {
            "label-width": "110",
            "show-error": false,
            "error-message-align": "right",
          },
        },
        [
          _c(
            "van-cell-group",
            [
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "ssdwmc",
                    expression: "'ssdwmc'",
                  },
                ],
                attrs: {
                  disabled: _vm.isDisabled("ssdwmc"),
                  required: _vm.isRequired("ssdwmc"),
                  name: "ssdwmc",
                  rules: _vm.getRules("ssdwmc"),
                  maxlength: "50",
                  autosize: "",
                  label: "实施单位名称",
                  placeholder: "请输入实施单位名称",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.ssdwmc,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "ssdwmc", $$v)
                  },
                  expression: "formData.ssdwmc",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "ssxm",
                    expression: "'ssxm'",
                  },
                ],
                attrs: {
                  "input-align": "right",
                  name: "ssxm",
                  required: _vm.isRequired("ssxm"),
                  value: _vm.formData.ssxm,
                  rules: _vm.getRules("ssxm"),
                  label: "所属项目",
                  placeholder: "请选择项目",
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.ssxm,
                            placeholder: "请选择项目",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.ssxm, "ssxm")
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.ssxm.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.ssxm, "show", $$v)
                              },
                              expression: "ssxm.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择项目",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.ssxm.show = false
                                },
                                "click-right": function ($event) {
                                  return _vm.popupSubmitSsxm("ssxm", {
                                    label: "projectName",
                                    value: "projectId",
                                  })
                                },
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.pickerSearch(
                                    $event,
                                    _vm.ssxm,
                                    "projectName"
                                  )
                                },
                              },
                              model: {
                                value: _vm.ssxm.filterText,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ssxm, "filterText", $$v)
                                },
                                expression: "ssxm.filterText",
                              },
                            }),
                            _c("van-picker", {
                              ref: "ssxm",
                              attrs: {
                                duration: 0,
                                "value-key": "projectName",
                                columns: _vm.ssxm.filteredData,
                              },
                              on: {
                                cancel: function ($event) {
                                  _vm.ssxm.show = false
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "xmfzr",
                    expression: "'xmfzr'",
                  },
                ],
                attrs: {
                  required: _vm.isRequired("xmfzr"),
                  name: "flowName",
                  label: "项目负责人",
                  placeholder: "项目负责人",
                  "input-align": "right",
                  rules: _vm.getRules("xmfzr"),
                },
                domProps: { value: _vm.formData.xmfzr },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.xmfzr[0]?.name,
                            placeholder: "请选择项目负责人",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(
                                _vm.deptUserTreeAll,
                                "xmfzr"
                              )
                            },
                          },
                        }),
                        _c(
                          "van-popup",
                          {
                            attrs: { position: "bottom" },
                            model: {
                              value: _vm.deptUserTreeAll.show,
                              callback: function ($$v) {
                                _vm.$set(_vm.deptUserTreeAll, "show", $$v)
                              },
                              expression: "deptUserTreeAll.show",
                            },
                          },
                          [
                            _c("van-nav-bar", {
                              attrs: {
                                title: "选择项目负责人",
                                "left-text": "取消",
                                "right-text": "确定",
                              },
                              on: {
                                "click-left": function ($event) {
                                  _vm.deptUserTreeAll.show = false
                                },
                                "click-right": _vm.handlePopupSubmit,
                              },
                            }),
                            _c("van-search", {
                              attrs: { clearable: "", shape: "round" },
                              on: {
                                input: function ($event) {
                                  return _vm.treeSearch($event, _vm.$refs.tree)
                                },
                              },
                              model: {
                                value: _vm.deptUserTreeAll.filterText,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.deptUserTreeAll,
                                    "filterText",
                                    $$v
                                  )
                                },
                                expression: "deptUserTreeAll.filterText",
                              },
                            }),
                            _c(
                              "div",
                              {
                                staticClass: "h-vh-50",
                                staticStyle: { "overflow-y": "auto" },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "p-10" },
                                  [
                                    _c("el-tree", {
                                      ref: "tree",
                                      attrs: {
                                        "node-key": "uuid",
                                        "check-strictly": "",
                                        data: _vm.deptUserTreeAll.data,
                                        "filter-node-method": _vm.filterNode,
                                        "check-on-click-node": "",
                                        "show-checkbox": "",
                                      },
                                      on: {
                                        "check-change": function ($event) {
                                          return _vm.singleChoice(
                                            $event,
                                            _vm.$refs.tree
                                          )
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "xmwcrq",
                    expression: "'xmwcrq'",
                  },
                ],
                attrs: {
                  required: _vm.isRequired("xmwcrq"),
                  name: "xmwcrq",
                  label: "项目完成日期",
                  placeholder: "项目完成日期",
                  "input-align": "right",
                  rules: _vm.getRules("xmwcrq"),
                },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("view-item", {
                          attrs: {
                            value: _vm.formData.xmwcrq,
                            placeholder: "请选择项目完成日期",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.isShowPopup(_vm.xmwcrq, "xmwcrq")
                            },
                          },
                        }),
                        _c("van-calendar", {
                          ref: "xmwcrq",
                          attrs: {
                            "show-confirm": false,
                            title: "选择项目完成日期",
                          },
                          on: { confirm: _vm.xmwcrqConfirm },
                          model: {
                            value: _vm.xmwcrq.show,
                            callback: function ($$v) {
                              _vm.$set(_vm.xmwcrq, "show", $$v)
                            },
                            expression: "xmwcrq.show",
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.formData.xmwcrq,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "xmwcrq", $$v)
                  },
                  expression: "formData.xmwcrq",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "sszpm",
                    expression: "'sszpm'",
                  },
                ],
                attrs: {
                  readonly: _vm.isDisabled("sszpm"),
                  type: "number",
                  required: _vm.isRequired("sszpm"),
                  rules: _vm.getRules("sszpm"),
                  name: "sszpm",
                  maxlength: "50",
                  autosize: "",
                  label: "实施总平米数(㎡)",
                  placeholder: "请输入实施总平米数",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.sszpm,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "sszpm", $$v)
                  },
                  expression: "formData.sszpm",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "xmszdq",
                    expression: "'xmszdq'",
                  },
                ],
                attrs: {
                  readonly: _vm.isDisabled("xmszdq"),
                  required: _vm.isRequired("xmszdq"),
                  name: "xmszdq",
                  rules: _vm.getRules("xmszdq"),
                  type: "textarea",
                  maxlength: "200",
                  rows: "3",
                  autosize: "",
                  label: "项目所在地区",
                  "show-word-limit": "",
                  placeholder: "请输入项目所在地区",
                  "input-align": "right",
                },
                model: {
                  value: _vm.formData.xmszdq,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "xmszdq", $$v)
                  },
                  expression: "formData.xmszdq",
                },
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "shjlfj",
                    expression: "'shjlfj'",
                  },
                ],
                staticClass: "fileValueBox",
                attrs: {
                  "input-align": "right",
                  name: "shjlfj",
                  required: _vm.isRequired("shjlfj"),
                  label: "上传审核记录表",
                  placeholder: "请上传文件",
                },
                domProps: { value: _vm.formData.shjlfj },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("uploadFiles", {
                          attrs: {
                            disabled: _vm.isDisabled("shjlfj"),
                            files: _vm.formData.shjlfj,
                            "module-type": "flow",
                          },
                          on: {
                            fileRemove: (removedFile) =>
                              _vm.handleFileRemove(
                                removedFile,
                                "formData",
                                "shjlfj"
                              ),
                            success: (fileList) => {
                              _vm.uploadSuccess(fileList, "shjlfj")
                            },
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("van-field", {
                directives: [
                  {
                    name: "f-show",
                    rawName: "v-f-show",
                    value: "yjcfbfj",
                    expression: "'yjcfbfj'",
                  },
                ],
                staticClass: "fileValueBox",
                attrs: {
                  "input-align": "right",
                  name: "yjcfbfj",
                  required: _vm.isRequired("yjcfbfj"),
                  label: "业绩拆分电子表",
                  placeholder: "请上传业绩拆分电子表",
                },
                domProps: { value: _vm.formData.yjcfbfj },
                scopedSlots: _vm._u([
                  {
                    key: "input",
                    fn: function () {
                      return [
                        _c("uploadFiles", {
                          attrs: {
                            disabled: _vm.isDisabled("yjcfbfj"),
                            files: _vm.formData.yjcfbfj,
                            "module-type": "flow",
                          },
                          on: {
                            fileRemove: (removedFile) =>
                              _vm.handleFileRemove(
                                removedFile,
                                "formData",
                                "yjcfbfj"
                              ),
                            success: (fileList) => {
                              _vm.uploadSuccess(fileList, "yjcfbfj")
                            },
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "font-32 font-weight-500 cor-00 m-t-26" }, [
        _vm._v("流程"),
      ]),
      !_vm.$route.query.reSend &&
      (_vm.processInstanceId || _vm.$route.query.processInstanceId)
        ? _c("flowTrace", {
            staticClass: "m-t-20",
            attrs: {
              flowTraceList: _vm.flowTrace,
              processInfo: _vm.processData,
            },
          })
        : _c("approver", {
            ref: "approver",
            staticClass: "m-t-20",
            attrs: { processData: _vm.processData, formData: _vm.formData },
            on: { addUser: _vm.addUser },
          }),
      _c("bottom-bar", { on: { submit: _vm.submit, mention: _vm.mention } }),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.approver.show,
            callback: function ($$v) {
              _vm.$set(_vm.approver, "show", $$v)
            },
            expression: "approver.show",
          },
        },
        [
          _c("van-nav-bar", {
            attrs: {
              title: "选择办理人",
              "left-text": "取消",
              "right-text": "确定",
            },
            on: {
              "click-left": function ($event) {
                _vm.approver.show = false
              },
              "click-right": _vm.approverPopupSubmit,
            },
          }),
          _c("van-search", {
            attrs: { clearable: "", shape: "round" },
            on: {
              input: function ($event) {
                return _vm.treeSearch($event, _vm.$refs.approverTree)
              },
            },
            model: {
              value: _vm.approver.filterText,
              callback: function ($$v) {
                _vm.$set(_vm.approver, "filterText", $$v)
              },
              expression: "approver.filterText",
            },
          }),
          _c(
            "div",
            { staticClass: "h-vh-50", staticStyle: { "overflow-y": "auto" } },
            [
              _c(
                "div",
                { staticClass: "p-10" },
                [
                  _c("el-tree", {
                    ref: "approverTree",
                    attrs: {
                      "node-key": "uuid",
                      "check-strictly": "",
                      data: _vm.approver.data,
                      "filter-node-method": _vm.filterNode,
                      "check-on-click-node": "",
                      "show-checkbox": "",
                    },
                    on: {
                      "check-change": function ($event) {
                        return _vm.approverCheckChange(
                          $event,
                          _vm.$refs.approverTree
                        )
                      },
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }